import React, { useEffect, useState } from "react";
import { AllSettingsOptionsDTO } from "../models/Settings/AllSettingsOptionsDTO";
import { SettingsService } from "../services/SettingsService";

// modulos disponiveis + tipos de assistencia disponiveis
interface AvailableModulesContextProps {
  availableModules: string[];
  assistanceTypes: string[];
  reminderStatusOptions: string[];
  importOptions: string[];
  counterOptions: string[];
  statusOptions: string;
  pageSizeOptions: string;
  workshopCardsPerPage: number;
  reactAppName: string;
  workOrderName: string;
  canTechnicianCreateAssistances: boolean;
  canTechnicianAddInterventionsForOthers: boolean;
  canTechnicianSeeAllAssistances: boolean;
}

const AvailableModulesContext =
  React.createContext<AvailableModulesContextProps>({
    availableModules: [],
    assistanceTypes: [],
    reminderStatusOptions: [],
    importOptions: [],
    counterOptions: [],
    statusOptions: "",
    pageSizeOptions: "",
    workshopCardsPerPage: 6,
    reactAppName: "",
    workOrderName: "",
    canTechnicianCreateAssistances: true,
    canTechnicianAddInterventionsForOthers: true,
    canTechnicianSeeAllAssistances: true,
  });

interface AvailableModulesProviderWrapperProps {
  children?: any;
}
export const AvailableModulesProviderWrapper = (
  props: AvailableModulesProviderWrapperProps
) => {
  const [availableModules, setAvailableModules] = useState<string[]>([]);
  const [assistanceTypes, setAssistanceTypes] = useState<string[]>([]);
  const [reminderStatusOptions, setReminderStatusOptions] = useState<string[]>([]);
  const [importOptions, setImportOptions] = useState<string[]>([]);
  const [counterOptions, setCounterOptions] = useState<string[]>([]);
  const [statusOptions, setStatusOptions] = useState<string>("");
  const [pageSizeOptions, setPageSizeOptions] = useState<string>("");
  const [workshopCardsPerPage, setWorkshopCardsPerPage] = useState<number>(6);
  const [reactAppNameOptions, setReactAppNameOptions] = useState<string>("");
  const [workOrderNameOptions, setWorkOdrerNameOptions] = useState<string>("");
  const [canTechnicianCreateAssistances, setCanTechnicianCreateAssistances] = useState<boolean>(true);
  const [canTechnicianAddInterventionsForOthers, setCanTechnicianAddInterventionsForOthers] = useState<boolean>(true);
  const [canTechnicianSeeAllAssistances, setCanTechnicianSeeAllAssistances] = useState<boolean>(true);
  const service = new SettingsService();

  useEffect(() => {
    const fetchAllSettings = async () => {
      const allSettingsResponse = await service.GetAllSettingsOptions();
      if (allSettingsResponse.success && allSettingsResponse.obj) {
        const settings: AllSettingsOptionsDTO = allSettingsResponse.obj;
        setAvailableModules(settings.availableModules || []);
        setAssistanceTypes(settings.assistanceTypes || []);
        setReminderStatusOptions(settings.reminderStatusOptions || []);
        setImportOptions(settings.importOptions || []);
        setStatusOptions(settings.statusOptions || "");
        setPageSizeOptions(settings.pageSizeOptions || "");
        setWorkshopCardsPerPage(Number(settings.workshopCardsPerPageOptions) > 0 ? Number(settings.workshopCardsPerPageOptions) : 6);
        setCounterOptions(settings.counterOptions || []);
        setReactAppNameOptions(settings.reactAppNameOptions || "");
        setWorkOdrerNameOptions(settings.workOrderNameOptions || "");
        setCanTechnicianCreateAssistances(settings.canTechnicianCreateAssistances?.toUpperCase() === "TRUE");
        setCanTechnicianAddInterventionsForOthers(settings.canTechnicianAddInterventionsForOthers?.toUpperCase() === "TRUE");
        setCanTechnicianSeeAllAssistances(settings.canTechnicianSeeAllAssistances?.toUpperCase() === "TRUE");
      } else {
        setAvailableModules([]);
        setAssistanceTypes([]);
        setReminderStatusOptions([]);
        setImportOptions([]);
        setStatusOptions("");
        setPageSizeOptions("");
        setWorkshopCardsPerPage(6);
        setCounterOptions([]);
        setReactAppNameOptions("");
        setWorkOdrerNameOptions("");
        setCanTechnicianCreateAssistances(true);
        setCanTechnicianAddInterventionsForOthers(true);
        setCanTechnicianSeeAllAssistances(true);
      }
    };
    fetchAllSettings();
  }, []);

  return (
    <AvailableModulesContext.Provider
      value={{
        availableModules: availableModules,
        assistanceTypes: assistanceTypes,
        reminderStatusOptions: reminderStatusOptions,
        importOptions: importOptions,
        counterOptions: counterOptions,
        statusOptions: statusOptions,
        pageSizeOptions: pageSizeOptions,
        workshopCardsPerPage: workshopCardsPerPage,
        reactAppName: reactAppNameOptions,
        workOrderName: workOrderNameOptions,
        canTechnicianCreateAssistances: canTechnicianCreateAssistances,
        canTechnicianAddInterventionsForOthers: canTechnicianAddInterventionsForOthers,
        canTechnicianSeeAllAssistances: canTechnicianSeeAllAssistances,
      }}
    >
      {props.children}
    </AvailableModulesContext.Provider>
  );
}

export const useAvailableModulesContext = () =>
  React.useContext(AvailableModulesContext);
